import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';

import { signInActions } from 'src/store/modules/signin';
import {
  userActions,
  accountErrorSel,
  userDataSel,
  emailUpdateSel
} from 'src/store/modules/user';

import UserUpdateInfo from './UserUpdateInfo';

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signInActions.signout()),
  updateUserInfo: (email: string, phone: string) =>
    dispatch(userActions.updateUserInfo(email, phone))
});

const mapStateToProps = (state: any) => ({
  error: accountErrorSel(state),
  userData: userDataSel(state),
  emailUpdated: emailUpdateSel(state)
});

export const pureComponent = UserUpdateInfo;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(UserUpdateInfo));

interface IDispatchFromProps {
  signout(): void;
  updateUserInfo(email: string, phone: string): void;
}
